// Write your code here
import './index.css'
import { useNavigate } from 'react-router-dom';

const AppItem = props => {
  const {appDetails,onClickAppItemUpdate, isActive} = props
  const {appName, imageUrl, appId} = appDetails
  const navigate = useNavigate();

  const onClickTab = () => {
    onClickAppItemUpdate(appId)
    navigate('/billers-page', { state: { selectedApp: appName.toUpperCase() } });
  };

  return (
    <li className="app-item" onClick={onClickTab}>
      <img src={imageUrl} alt={appName} className="app-logo" />
      <p className="app-name">{appName}</p>
    </li>
  )
}

export default AppItem
